var map = {
	"./01.png": "NZ8Z",
	"./02.png": "exG2",
	"./03.png": "ZLk7",
	"./04.png": "KoNu",
	"./05.png": "ln6I",
	"./06.png": "wFP5",
	"./07.png": "ksuc",
	"./08.png": "upNx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+ZyZ";